import JsonWebToken from 'jsonwebtoken';
import {getValue, setValue} from './localStorage';
import {forOwn, isEmpty, isEqual, pickBy} from './lodash';
import history from '../routes/history';
import queryString from 'query-string';
import Link from '../config/constants';
import store from '../store';
import I18n from '../config/locales';

export const decodeToken = token => {
  let decoded = { error: null };
  try {
    decoded = JsonWebToken.decode(token)['data'];
    decoded['error'] = null;
  } catch (error) {
    console.log('JWT token verify error:', error);
    decoded.error = error.message;
  }
  return decoded;
};

export const getFleetDashboardToken = () => {
  const fleetDashBoardLink = store.getState().accountReducer.fleetDashBoardLink;
  const  split = fleetDashBoardLink?.split('?');
  return  split && split[1] || '';
}

export const isReferrerWhitelisted = () => {
  const whitelistedDomains = ['enphase.com'];
  return whitelistedDomains.some((domain) =>
    document?.referrer?.includes(domain)
  );
};
export const getToken = () => {
  var token = store.getState().appReducer.enlightenManagerToken;
  if (token && isReferrerWhitelisted()) {
    return token;
  }
  token = getValue('_enlighten_manager_token');
  if (!token) {
    token = getValue('enlighten_manager_token_' + window.build_environment);
  }
  return token;
}

export const getEnvSpecificToken = () => getValue(`enlighten_manager_token_${window.build_environment}`)

export const setToken = value => setValue('_enlighten_manager_token', value);

export const getTrainingDashboardTokenFromCookies = () =>
  getValue('training_dashboard_token');

export const getSolargrafToken = () => getValue('_solargraf_token');

export const setSolargrafToken = value => setValue('_solargraf_token', value);

export const forwardTo = location => history.push(location);

export const getProntoToken = () => getValue('_365_pronto_token');

export const setProntoToken = value => setValue('_365_pronto_token', value)

export const goBack = () => history.goBack();

let belongsToList = {};

export const getBelongsTo = country => {
  belongsToList = {
    belongsToAus: isEqual(country, 'AU'),
    belongsToUs: isEqual(country, 'US'),
    belongsToIn: isEqual(country, 'IN'),
    belongsToMx: isEqual(country, 'MX'),
    belongsToBe: isEqual(country, 'BE'),
    belongsToNl: isEqual(country, 'NL'),
    belongsToFr: isEqual(country, 'FR'),
    belongsToDe: isEqual(country, 'DE'),
    belongsToUk: isEqual(country, 'UK'),
    belongsToEs: isEqual(country, 'ES'),
    belongsToCh: isEqual(country, 'CH'),
    belongsToNc: isEqual(country, 'NC'),
    belongsToNz: isEqual(country, 'NZ'),
    belongsToIt: isEqual(country, 'IT'),
    belongsToPa: isEqual(country, 'PA'),
    belongsToCo: isEqual(country, 'CO'),
    belongsToCr: isEqual(country, 'CR'),
    belongsToBr: isEqual(country, 'BR'),
    belongsToPr: isEqual(country, 'PR'),
    belongsToAw: isEqual(country, 'AW')
  };
  return belongsToList;
};

export const getCountryBasedLink = key => {
  const {
    belongsToAus: AU = false,
    belongsToDe: DE = false,
    belongsToNl: NL = false,
    belongsToBe: BE = false,
    belongsToIn: IN = false,
    belongsToMx: MX = false,
    belongsToBr: BR = false,
    belongsToUs: US = false,
    belongsToNc: NC = false,
    belongsToNz: NZ = false,
    belongsToFr: FR = false,
    belongsToUk: UK = false,
    belongsToEs: ES = false,
    belongsToCh: CH = false,
    belongsToIt: IT = false
  } = belongsToList;
  const countries = { AU, DE, NL, BE, IN, MX, BR, US, NC, NZ, FR, UK, ES, CH, IT };
  const installerCountry = pickBy(countries, value => value);
  const country = Object.keys(installerCountry).toString();
  return Link[country] ? Link[country][key] || Link['US'][key] : Link['US'][key];
};

export const airbrakeProject = () => {
  const { airbrakeProjectId, airbrakeProjectKey, companyId } = store.getState().appReducer;

  return {
    airbrakeProjectId,
    airbrakeProjectKey,
    companyId
  };
};

export const enlightenLinks = () => ({
  dashboard: { name: I18n.t('utils.dashboard'), url: 'dashboard' },
  systems: { name: I18n.t('utils.systems'), url: 'systems' },
  account: { name: I18n.t('utils.account'), url: 'account' },
  services: { name: I18n.t('utils.services'), url: 'account' },
  dataPrivacy: { name: I18n.t('utils.dataPrivacy'), url: 'account' },
  support: { name: I18n.t('utils.support'), url: getCountryBasedLink('support'), isExternal: true },
  admin: { name: I18n.t('utils.admin'), url: 'admin' },
  adminNew: { name: I18n.t('utils.adminNew'), url: 'admin-new' }
});

export const enlightenHomeownerLinks = () => ({
  systems: { name: I18n.t('utils.systems'), url: 'systems' },
  account: { name: I18n.t('utils.account'), url: 'account' },
  support: { name: I18n.t('utils.support'), url: getCountryBasedLink('support'), isExternal: true }
});

export const currencyFormater = number => {
  return new Intl.NumberFormat('en-US').format(number);
};

export const analyticCode = {
  production: 'UA-2434165-3',
  qa2: 'UA-2434165-9',
  development: 'UA-155727801-1'
};

export const measurementId = {
  production: 'G-HQDBGWJJGL',
  qa2: 'G-P6C6SGMX90',
  development: 'G-P6C6SGMX90'
};

export const handleFeedbackMenu = props => {
  const feedBackElement = document.getElementsByClassName('feedbackify')[0];
  if (feedBackElement) {
    const { search } = props.location;
    const { origin, platform } = queryString.parse(search);
    const fromIframe = origin === 'iframe';
    const fromITK = platform === 'itk';
    if (fromIframe || fromITK) {
      feedBackElement.style.display = 'none';
    } else if (feedBackElement.classList.contains('show')) {
      feedBackElement.style.display = 'block';
    }
  }
};

const defaultMessage = I18n.t('utils.defaultMessage');
export const handlePopupBlocker = (windowObj, message = defaultMessage) => {
  if (windowObj == null || typeof windowObj == 'undefined') alert(message);
  else windowObj.focus();
};

export const constructQueryString = queryObj => {
  let queryString = '';
  Object.keys(queryObj).forEach((queryKey, index) => {
    const queryConnector = index === 0 ? '?' : '&';
    queryString = queryString + `${queryConnector}${queryKey}=${queryObj[queryKey]}`;
  });
  return queryString;
};

// add params to the url
// remove duplicate params from the url
// e.g. url : /manager/account?platform=itk
// e.g. queryParamsString : ?page=services&platform=itk
export const constructUrlWithParams = (url, queryParamsString) => {
  if (!url) {
    return url;
  }
  const urls = url.split('?');
  if (!urls[1]) {
    return urls[0] + queryParamsString;
  }
  const urlQueryObj = queryString.parse(urls[1]);
  const queryParamsObj = queryString.parse(queryParamsString);
  for (const key in urlQueryObj) {
    if (!queryParamsObj[key]) {
      queryParamsObj[key] = urlQueryObj[key];
    }
  }
  return urls[0] + constructQueryString(queryParamsObj);
};

export const convertBytes = bytes => {
  if (bytes >= 1073741824) {
    bytes = (bytes / 1073741824).toFixed(2) + ' GB';
  } else if (bytes >= 1048576) {
    bytes = (bytes / 1048576).toFixed(2) + ' MB';
  } else if (bytes >= 1024) {
    bytes = (bytes / 1024).toFixed(2) + ' KB';
  } else if (bytes > 1) {
    bytes = bytes + ' bytes';
  } else if (bytes === 1) {
    bytes = bytes + ' byte';
  } else {
    bytes = '0 bytes';
  }
  return bytes;
};

export const isCompanyIdValid = companyId => {
  const isValid =
    typeof companyId === 'number' && !isNaN(companyId) ? true : !(isEmpty(companyId) || isNaN(parseInt(companyId)));
  return isValid;
};

export const getAddressForLatLng = (details, countryList, stateList) => {
  const { country, state, city, zip, address1, address2 } = details;
  const address = [];
  const nextAddressField = [];
  const lastAddressField = [];
  const countryArray = countryList && countryList.length ? countryList.find(list => list[1] === country) : [ '', '' ];
  const stateArray = stateList && stateList.length ? stateList.find(list => list[1] === state) : [ '', '' ];
  const newCountry = countryArray && countryArray.length && countryArray[0] ? countryArray[0] : '';
  const newState = stateArray && stateArray.length && stateArray[0] ? stateArray[0] : '';
  [ address1, address2, city, newState, zip, newCountry ].forEach(value => {
    if (!isEmpty(value)) {
      address.push(value);
    }
  });
  [ city, newState, newCountry ].forEach(value => {
    if (!isEmpty(value)) {
      nextAddressField.push(value);
    }
  });
  [ newState, newCountry ].forEach(value => {
    if (!isEmpty(value)) {
      lastAddressField.push(value);
    }
  });
  const addressString = address.join(', ');
  const nextAddressFields = [ nextAddressField.join(', '), zip, lastAddressField.join(', ') ];
  return { addressString, nextAddressFields };
};

export const getSegregatedAddress = addressObject => {
  let addresses = addressObject.address_components;
  const streetNumber = addresses.find(
    address => address.types.includes('street_number') || address.types.includes('premise')
  );
  const locality = addresses.find(address => address.types.includes('locality') || address.types.includes('political'));
  const route = addresses.find(
    address => address.types.includes('route') || address.types.includes('sublocality_level_1')
  );
  const addressLocality = locality ? locality.long_name : '';
  const address1 = streetNumber && route ? [ streetNumber.long_name, route.long_name ].join(', ') : '';
  const city = addresses.find(address => address.types.includes('locality'));
  const state = addresses.find(address => address.types.includes('administrative_area_level_1'));
  const zip = addresses.find(address => address.types.includes('postal_code'));
  const country = addresses.find(address => address.types.includes('country'));
  const latitude = addressObject.geometry.location.lat();
  const longitude = addressObject.geometry.location.lng();
  return {
    addressLocality,
    address1,
    city,
    state,
    zip,
    country,
    latitude,
    longitude
  };
};

export const custRenderHTML = (content, localeData = {}) => {
  forOwn(localeData, (value, key) => {
    content = content.replace(/\$\{key\}/g, value);
  });

  return content;
};
